<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>Copy Supplier</template>
    <v-row>
      <v-col class="pb-0"
        ><v-text-field
          v-model="newName"
          label="New Name"
          :outlined="outlinedInputs"
        ></v-text-field
      ></v-col>
      <v-col sm="3">
        <v-text-field
          v-model="newCode"
          label="New Codde"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-container class="py-0">
          <v-row align="baseline">
            <v-col class="py-0">
              <v-switch
                v-model="supplierContent"
                label="Supplier Content"
              ></v-switch>
            </v-col>
            <v-col class="py-0">
              <v-switch v-model="paymentTerms" label="Payment Terms"></v-switch>
            </v-col>
            <v-col class="py-0">
              <v-switch v-model="customFields" label="Custom Fields"></v-switch>
            </v-col>
            <v-col class="py-0">
              <v-switch v-model="discounts" label="Discounts"></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-switch v-model="supplierServices" label="Services"></v-switch>
            </v-col>
            <v-col class="py-0">
              <v-switch
                :disabled="!supplierServices"
                v-model="servicePrices"
                label="Rates"
              ></v-switch>
            </v-col>
            <!-- https://tracker.globetrack.ie/issues/7774
            <v-col class="py-0">
              <v-switch
                :disabled="!supplierServices"
                v-model="serviceTaxes"
                label="Taxes"
              >
              </v-switch>
            </v-col>
             -->
            <v-col class="py-0">
              <v-switch
                :disabled="!supplierServices"
                v-model="serviceExtras"
                label="Extras"
              ></v-switch>
            </v-col>
            <v-col class="py-0">
              <v-switch
                :disabled="!supplierServices"
                v-model="allocations"
                label="Allocations/Closeouts"
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Copy</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../shared/BasicDialog";
const CLONE_SUPPLIER = gql`
  mutation cloneSupplier($input: CloneSupplierInput!) {
    cloneSupplier(input: $input) {
      id
      name
    }
  }
`;
export default {
  name: "clone-supplier",

  props: {
    show: {
      type: Boolean,
      default: () => true,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
  },

  data() {
    return {
      newName: this.value ? `${this.value.name} Copy` : "New Name",
      newCode: this.value ? `${this.value.code} Copy` : "NEW_CODE",
      supplierServices: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      supplierContent: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      paymentTerms: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      customFields: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      discounts: !this.$store.getters.hasAccessTo("suppliers:copy_options_off"),
      serviceExtras: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      serviceContent: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      servicePrices: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      serviceTaxes: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      allocations: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
    };
  },

  computed: {
    isValid() {
      return this.newName != "" && this.value && this.value.id != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.newName = `${newVal.name} Copy`;
    },
  },

  methods: {
    onSave() {
      const input = {
        id: this.value.id,
        newName: this.newName,
        code: this.newCode,
        supplierContent: this.supplierContent,
        paymentTerms: this.paymentTerms,
        customFields: this.customFields,
        discounts: this.discounts,
        supplierServices: this.supplierServices,
        serviceExtras: this.supplierServices && this.serviceExtras,
        serviceContent: this.supplierServices && this.serviceContent,
        servicePrices: this.supplierServices && this.servicePrices,
        serviceTaxes: this.supplierServices && this.serviceTaxes,
        allocations: this.supplierServices && this.allocations,
      };
      this.cloneSupplier(input);
    },
    async cloneSupplier(input) {
      try {
        const result = await this.$apollo.mutate({
          mutation: CLONE_SUPPLIER,
          variables: { input },
        });
        //console.log(result);
        if (result.data.cloneSupplier.id) {
          this.$emit("complete", { ...result.data.cloneSupplier });
        }
      } catch (error) {
        //console.log(error);
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/CloneSupplier.vue